import Typography from "@mui/material/Typography";
import BatteryIcon from "assets/svgIcons/BatteryIcon";
import UnKnowIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/UnKnownIcon";
import BatteryWithPowerIcon from "assets/svgIcons/BatteryWithPowerIcon";
import OnChargeIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/OnCharge";
import { batteryOK } from "_helperFunctions/batteryOK";
import { batteryCritical } from "_helperFunctions/batteryCritical";
import { batteryWarning } from "_helperFunctions/batteryWarning";
import { batteryLevel } from "_helperFunctions/batteryLevel";
import { shouldDisplayBattery } from "_helperFunctions/shouldDisplayBattery";
import { useSelector } from "react-redux";

export function RenderBatteryColumn({ car, getUserRole }) {
  const { siteSettingsData } = useSelector((state) => state.commonReducers);

  if (!car) return null;

  // For charge history when we ready: 
  // const chargeHistory = getChargeHistoryAction?.find?.(c => c.CarNumber === car?.CarNumber);
  // Boolean(chargeHistory?.ChargeEvents?.length);

  const batteryColor = () => {
    if (!car.UseVoltage) {
      if (car.IsCharging) {
        if ((car.BatteryLevel >= 80) && (car.BatteryLevel <= 100)) {
          return 'green';
        } else {
          return 'black';
        }
      } else if (batteryCritical(car, siteSettingsData)) {
        return 'red';
      } else if (batteryWarning(car, siteSettingsData)) {
        return 'orange';
      } else if (batteryOK(car, siteSettingsData)) {
        return 'green';
      } else {
        return 'black';
      }
    } else {
      // UseVoltage true
      if (batteryCritical(car, siteSettingsData)) {
        return 'red';
      } else if (batteryWarning(car, siteSettingsData)) {
        return 'orange';
      } else if (batteryOK(car, siteSettingsData)) {
        return 'green';
      } else {
        return 'black';
      }
    }
  }

  // Render logic as per renderCell
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      {shouldDisplayBattery(car, getUserRole) &&
        <Typography variant="body2" component="span" sx={{ color: batteryColor(), fontWeight: 500 }}>
          {batteryLevel(car, getUserRole, siteSettingsData)}
        </Typography>
      }
    </span>
  );
}

function RenderBatteryIcon({ car }) {
  const { siteSettingsData } = useSelector((state) => state.commonReducers);

  const unknownLevel = car.BatteryLevel > 100;

  if (car.IsCharging) {
    if (car.BatteryLevel >= 80) return <BatteryWithPowerIcon />;
    else return <OnChargeIcon width={37} height={22} />;
  } else {
    if (batteryCritical(car, siteSettingsData)) {
      return <BatteryIcon color="#FA3C30" />;
    } else if (batteryOK(car, siteSettingsData)) {
      return <BatteryIcon color="green" />;
    } else if (batteryWarning(car, siteSettingsData)) {
      return <BatteryIcon color="orange" />;
    } else if (unknownLevel) {
      return <UnKnowIcon width={40} height={24} />;
    } else {
      return <span></span>;
    }
  }
}

export default RenderBatteryIcon;
